import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { removeChargingServiceImage } from '../../api/charging-service.ts';
import { RemoveChargingServiceImageRequest } from '../../api/requests/charging-service-request.ts';

export default function useRemoveChargingServiceImage(): UseMutationResult<
  Awaited<ReturnType<typeof removeChargingServiceImage>>,
  Error,
  RemoveChargingServiceImageRequest
> {
  return useMutation({
    mutationFn: removeChargingServiceImage,
  });
}
